import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { EditorFeedbackBlock } from '../../_blocks/Comments/CommentsBlock';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';

export type EditorFeedbackWidget = WidgetShape<[EditorFeedbackBlock], WidgetType.editorFeedback>;

export function EditorFeedbackWidget({ blocks, ...headerProps }: EditorFeedbackWidget) {
  const { t } = useSonTranslation('EditorFeedback');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={WidgetType.editorFeedback}
      icon={Icons.CHAT_BUBBLE}
      title={t('widgetTitle')}
    >
      {blocks[0] && <EditorFeedbackBlock {...blocks[0]} />}
    </DefaultWidgetWithHeader>
  );
}
